// From TanStack router https://github.com/TanStack/router/blob/beta/packages/store/src/index.ts

export class Store {
  constructor(initialState, options) {
    this.listeners = new Set();
    this.batching = false;
    this.queue = [];
    this.subscribe = listener => {
      this.listeners.add(listener);
      let unsub = () => {};
      if (this.options && this.options.onSubscribe) {
        unsub = this.options.onSubscribe(listener, this);
      }
      return () => {
        this.listeners.delete(listener);
        unsub();
      };
    };
    this.setState = updater => {
      const previous = this.state;
      if (this.options && this.options.updateFn) {
        this.state = this.options.updateFn(previous)(updater);
      } else {
        this.state = updater(previous);
      }
      if (this.state === previous) return;
      this.queue.push(() => {
        this.listeners.forEach(listener => listener(this.state, previous));
        if (this.options && this.options.onUpdate) {
          this.options.onUpdate(this.state, previous);
        }
      });
      this._flush();
    };
    this._flush = () => {
      if (this.batching) return;
      this.queue.forEach(cb => cb());
      this.queue = [];
    };
    this.batch = cb => {
      this.batching = true;
      cb();
      this.batching = false;
      this._flush();
    };
    this.state = initialState;
    this.options = options;
  }
}